module.exports = __webpack_public_path__ + "static/media/umacare.9fb01266.png";